/*
 * @Author: your name
 * @Date: 2021-08-08 12:12:31
 * @LastEditTime: 2023-03-02 16:29:16
 * @LastEditors: 迟长志 943512491@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /zq/src/App.js
 */
import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import 'antd/dist/antd.css';

import { HomePage } from './page/index.tsx';
import { About } from './page/about/index.tsx';
import { Example } from './page/study/mathematics/index.tsx';
import { MagicInstrument } from './page/magicInstrument/index.tsx';

export default function App() {
    return (<Router>
        <Switch>
            <Route path="/about" >
                <About />
            </Route>
            <Route path="/users" >
                <Users />
            </Route>
            <Route path="/mathematics" >
                {Example()}
                {/* <Example /> */}
            </Route>
            <Route path="/magicInstrument" >
                <MagicInstrument />
            </Route>
            <Route path="/" >
                <HomePage />
            </Route>

        </Switch>
    </Router>
    );
}

// function Home() {
//   return <h2>Home</h2>;
// }

function Users() {
    const obj = {
        "uuIds": "[\"ffcb44f37037ddb46d2984fc15bee380\"]"
    }
    const getBlob = (url) => {
        return new Promise((resolve) => {
            const xhr = new XMLHttpRequest();

            xhr.open('post', url, true);
            xhr.responseType = 'blob';
            xhr.setRequestHeader("Content-Type", "application/json;charset-UTF-8");
            if (xhr.readyState === 4 && xhr.status === 200) {
                let res = xhr.response;  //不是responseText。
                let blob = new Blob([res]);
                const blobUrl = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = blobUrl;
                a.download = "批量下载.zip";
                a.click();
                URL.revokeObjectURL(blobUrl); // 释放内存
                // setMoreAlertVisible(false);
            }

            xhr.send(JSON.stringify(obj));
        });
    };
    const ownloadBlobUrl = (blobUrl, filename) => {
        console.log(blobUrl);
        const eleLink = document.createElement('a');
        eleLink.style.display = 'none';
        // let filename = new Date().getTime() + '.xls';
        eleLink.href = blobUrl;
        eleLink.download = filename;
        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);
        window.URL.revokeObjectURL(blobUrl);
    }
    const onGetBlob = () => {
        getBlob('http://10.133.61.219:8093/template/down')
        // ownloadBlobUrl()
    }
    return <>
        <h2 onClick={() => onGetBlob()} > Users </h2>
        {/* http://10.133.61.219:8093/template/down */}
    </>
}